import Header from "Components/Header/Header";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { ErrorBoundary } from "../ErrorBoundary/ErrorBoundary";

interface IProps extends RouteComponentProps<any, any> { }

class ApplicationGrid extends React.Component<IProps> {
    public render() {
        return (
            <div>
                <Header location={this.props.history.location} />
                <ErrorBoundary>{this.props.children}</ErrorBoundary>
            </div>
        );
    }
}

export default withRouter(ApplicationGrid);


// WEBPACK FOOTER //
// ./src/Components/ApplicationGrid/ApplicationGrid.tsx